import { REGISTRATION_LOCAL_STORAGE_KEY } from '~/singlePageApp/screens/LiveStreamScreen/shared/constants';
import { parseLocalStorageData } from '~/utilities/util';
import { z } from 'zod';

export const savedRegistrationDataSchema = z.object({
  uid: z.string(),
  first_name: z.string(),
  last_name: z.string(),
  email: z.string(),
  // eslint-disable-next-line camelcase
  is_registrant_restricted: z.boolean(),
});

export const storedRegistrationDataSchema = z.array(
  z.object({
    id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    email: z.string(),
    role: z.literal('audience').optional(),
    eventId: z.string(),
    channelId: z.number().nullish(),
  }),
);

export type StoredRegistrationData = z.infer<typeof storedRegistrationDataSchema>;

const storedRegistrationDataDefaultValue: StoredRegistrationData = [];

export const getParsedStoredRegistrationData = (): StoredRegistrationData => {
  const parsedStoredRegistrationData = storedRegistrationDataSchema.safeParse(
    parseLocalStorageData(REGISTRATION_LOCAL_STORAGE_KEY, storedRegistrationDataDefaultValue),
  );

  return parsedStoredRegistrationData.success
    ? parsedStoredRegistrationData.data
    : storedRegistrationDataDefaultValue;
};
